module.exports = __webpack_public_path__ + "img/AD02.408ea2f7.png";